import React from 'react';
import ReactPlayer from 'react-player';
import { ChevronDownIcon } from 'lucide-react';
export function HeroSection() {
  return <div className="bg-orange-700 text-white" data-id="element-39">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 md:py-20 lg:py-24" data-id="element-40">
        <div className="text-center" data-id="element-41">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight mb-6 sm:mb-8 leading-tight px-2" data-id="element-42">
            De Novato a Pro con IA: páginas, VSLs y creativos en minutos
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl mb-8 sm:mb-10 text-orange-100 max-w-3xl mx-auto px-4" data-id="element-43">
            Clip de clase gratis
          </p>
          <div className="max-w-4xl mx-auto mb-8 sm:mb-10 px-2" data-id="element-44">
            <div className="bg-white rounded-lg shadow-2xl overflow-hidden" data-id="element-45">
              <div className="aspect-video" data-id="element-46">
                <ReactPlayer url="https://youtu.be/bx416gR2W9M" width="100%" height="100%" controls data-id="element-47" />
              </div>
            </div>
          </div>
          <div className="mt-8 sm:mt-12 flex flex-col items-center" data-id="element-48">
            <a href="#objection-handler" className="inline-flex flex-col items-center animate-bounce" data-id="element-49">
              <ChevronDownIcon className="h-10 w-10 sm:h-12 sm:w-12 text-yellow-400" strokeWidth={3} data-id="element-50" />
              <ChevronDownIcon className="h-10 w-10 sm:h-12 sm:w-12 text-yellow-400 -mt-5 sm:-mt-6" strokeWidth={3} data-id="element-51" />
              <ChevronDownIcon className="h-10 w-10 sm:h-12 sm:w-12 text-yellow-400 -mt-5 sm:-mt-6" strokeWidth={3} data-id="element-52" />
            </a>
          </div>
        </div>
      </div>
    </div>;
}